/* OMO collection filter panel + mobile filter tabs. */
(() => {
  const DESKTOP = '(min-width: 990px)';
  const MOBILE = '(max-width: 749px)';
  const CLOSE_MS = 180;

  let closeTimer;

  const panel = () => document.getElementById('OmoFilterPanel');

  const toggle = () =>
    document.querySelector('[data-omo-filter-toggle]');

  const isOpen = () => {
    const el = panel();

    return (
      el &&
      !el.hasAttribute('hidden') &&
      !el.classList.contains('is-closing')
    );
  };


  /* =========================================================
     PANEL OPEN / CLOSE
     ========================================================= */

  function open() {
    const el = panel();

    if (!el) return;

    clearTimeout(closeTimer);

    el.classList.remove('is-closing');
    el.removeAttribute('hidden');

    toggle()?.setAttribute('aria-expanded', 'true');

    initMobileTabs();
  }


  function close(focusToggle) {
    const el = panel();

    if (!el || el.hasAttribute('hidden')) return;

    toggle()?.setAttribute('aria-expanded', 'false');

    if (focusToggle) {
      toggle()?.focus();
    }

    /*
      Dawn's Escape handler may have collapsed a facet group.
      Keep every custom OMO group expanded.
    */
    el
      .querySelectorAll('details.omo-filter')
      .forEach((details) => {
        details.open = true;
      });


    const finish = () => {
      el.classList.remove('is-closing');
      el.setAttribute('hidden', '');
    };


    if (
      window
        .matchMedia(
          `${DESKTOP} and (prefers-reduced-motion: no-preference)`
        )
        .matches
    ) {
      el.classList.add('is-closing');

      closeTimer = setTimeout(
        finish,
        CLOSE_MS
      );
    } else {
      finish();
    }
  }


  /* =========================================================
     MOBILE TABS
     ========================================================= */

  function clearMobileActiveState(form) {
    form
      .querySelectorAll(
        '.omo-filter, .omo-sort'
      )
      .forEach((element) => {
        element.classList.remove(
          'is-omo-mobile-active'
        );
      });
  }


  function activateMobileTab(tabName) {
    const form =
      document.getElementById(
        'FacetFiltersForm'
      );

    if (!form) return;


    clearMobileActiveState(form);


    form
      .querySelectorAll(
        '[data-omo-filter-tab]'
      )
      .forEach((button) => {
        const active =
          button.dataset.omoFilterTab ===
          tabName;

        button.classList.toggle(
          'is-active',
          active
        );

        button.setAttribute(
          'aria-pressed',
          active ? 'true' : 'false'
        );
      });


    switch (tabName) {
      case 'size':
        form
          .querySelector(
            '.omo-filter--size'
          )
          ?.classList.add(
            'is-omo-mobile-active'
          );
        break;


      case 'color':
        form
          .querySelector(
            '.omo-filter--color'
          )
          ?.classList.add(
            'is-omo-mobile-active'
          );
        break;


      case 'categories':
        form
          .querySelector(
            [
              '.omo-filter--categories',
              '.omo-filter--category',
              '.omo-filter--product-type'
            ].join(',')
          )
          ?.classList.add(
            'is-omo-mobile-active'
          );
        break;


      case 'sort':
        /*
          Figma treats sorting and price
          as one visual panel.
        */
        form
          .querySelector('.omo-sort')
          ?.classList.add(
            'is-omo-mobile-active'
          );

        form
          .querySelector(
            '.omo-filter--price'
          )
          ?.classList.add(
            'is-omo-mobile-active'
          );
        break;
    }
  }


  function initMobileTabs() {
    if (
      !window.matchMedia(MOBILE).matches
    ) {
      return;
    }

    const form =
      document.getElementById(
        'FacetFiltersForm'
      );

    if (!form) return;


    const currentActive =
      form.querySelector(
        '[data-omo-filter-tab].is-active'
      );

    activateMobileTab(
      currentActive?.dataset.omoFilterTab ||
        'size'
    );
  }


  /* =========================================================
     EVENTS
     ========================================================= */

  document.addEventListener(
    'click',
    (event) => {

      const filterToggle =
        event.target.closest(
          '[data-omo-filter-toggle]'
        );

      if (filterToggle) {
        isOpen()
          ? close(false)
          : open();

        return;
      }


      const tab =
        event.target.closest(
          '[data-omo-filter-tab]'
        );

      if (tab) {
        activateMobileTab(
          tab.dataset.omoFilterTab
        );
      }
    }
  );


  document.addEventListener(
    'keyup',
    (event) => {
      if (
        event.code === 'Escape' &&
        isOpen()
      ) {
        close(true);
      }
    }
  );


  /* When Dawn replaces facet HTML through AJAX,
     initialise the returned OMO markup again. */
  const observer =
    new MutationObserver(() => {
      if (
        isOpen() &&
        window.matchMedia(MOBILE).matches
      ) {
        initMobileTabs();
      }
    });


  observer.observe(
    document.body,
    {
      childList: true,
      subtree: true
    }
  );


  window
    .matchMedia(MOBILE)
    .addEventListener(
      'change',
      () => {
        if (isOpen()) {
          initMobileTabs();
        }
      }
    );


  initMobileTabs();
})();